import $ from 'jquery'
import Backbone from 'backbone'
import BaseRouter from 'scoreboard/components/base-router'
import Nav from './home-nav'
import appDisplay from 'scoreboard/components/app-display'
import Welcome from './welcome'
import HomeAlerts from './alerts/home-alerts'
import MyMetrics from './my-metrics/my-metrics'
import MyTasks from './my-tasks/my-tasks'
import MetricUpdates from './metric-updates/metric-updates'
import MetricApprovals from './metric-approvals/metric-approvals'
import MetricUpdatesRequester from './metric-updates/metric-updates-requester'
import globals from 'scoreboard/components/globals'
import JsonStreamer from 'scoreboard/components/json-streamer'
import i18n from 'scoreboard/components/i18n'

var HomeRouter = BaseRouter.extend({

	routes: {
		'home/welcome(/)': 'welcome',
		'home/alerts(/)': 'homeAlerts',
		'home/my-tasks(/)': 'myTasks',
		'home/my-metrics(/)': 'myMetrics',
		'home/metric-updates/:nodeId/:periodId': 'metricUpdates',
		'home/metric-updates(/)': 'metricUpdates',
		'home/metric-approvals(/)': 'metricApprovals'
	},

	Nav: Nav,
	section: 'home',

	welcome: function() {
		appDisplay.display($.get('api/home/welcome'), function(data) {
			Backbone.trigger('change:unread', {numUnread: data.alerts.numUnread})
			return new Welcome({data})
		})
		this.selectNav('welcome')
	},

	homeAlerts: function() {
		appDisplay.display($.get('api/alerts'), function(data) {
			Backbone.trigger('change:unread', {numUnread: data.numUnread})
			return new HomeAlerts({data})
		})
		this.selectNav('alerts')
	},

	myTasks: function() {
		var myTasks = new MyTasks()
		appDisplay.display(myTasks)
		JsonStreamer.initiate(myTasks, { stream: 'initiatives', url: 'api/home/my-tasks' })
		this.selectNav('my-tasks')
	},

	myMetrics: function() {
		this.selectNav('my-metrics')

		if (this.handleNoCalendars({ clearNav: false, heading: i18n.get('home.myMetrics')})) {
			return
		}
		var myMetrics = new MyMetrics()
		appDisplay.display(myMetrics)
		JsonStreamer.initiate(myMetrics, { stream: 'metrics', url: 'api/home/my-metrics' })
	},

	metricUpdates: function(nodeId, periodId) {
		this.selectNav('metric-updates')

		if (this.handleNoCalendars({ clearNav: false, heading: i18n.get('home.metricUpdates')})) {
			return
		}

		var metricUpdates = new MetricUpdates({nodeId, periodId})
		// display right away or else infinite scroller tries to attach before
		// it has anything to attach to
		appDisplay.display(metricUpdates)

		var requester = new MetricUpdatesRequester()
		metricUpdates.requester = requester
		this.listenToOnce(requester, 'orgs', metricUpdates.orgs.bind(metricUpdates))
		this.listenTo(requester, 'periods', metricUpdates.periods.bind(metricUpdates))
		this.listenTo(requester, 'updatesAnyMetric', metricUpdates.updatesAnyMetric.bind(metricUpdates))
		this.listenTo(requester, 'stream', metricUpdates.stream.bind(metricUpdates))
		requester.getForPeriod(globals.periodId, true)
		this.listenTo(metricUpdates.periodDisplay, 'change:period', function(periodId) {
			requester.getForPeriod(periodId, false)
			globals.periodId = periodId
		})
	},

	metricApprovals: function() {
		this.selectNav('metric-approvals')

		if (this.handleNoCalendars({ clearNav: false, heading: i18n.get('home.approveMetrics')})) {
			return
		}

		appDisplay.display($.get('api/scorecards/metric-approvals'), function(data) {
			return new MetricApprovals({
				data: data.metrics,
				seriesBySnId: data.seriesBySnId
			})
		})
	},

	selectNav(value) {
		this.nav().then(nav => {
			nav.select(value)
		})
	}

})

export default HomeRouter

HomeRouter.__filename__ = 'home/home-router.js'
